import { dispatchErrorOccurred, dispatchUnexpectedErrorOccurred, } from "./events/erroroccurred";
export async function parseJsonResponse(controller, response) {
    if (response.status >= 500) {
        dispatchUnexpectedErrorOccurred(controller, new Error(await response.text()));
        return;
    }
    let responseJson;
    try {
        responseJson = await response.json();
    }
    catch (error) {
        if (response.redirected) {
            const responseUrl = new URL(response.url);
            if (responseUrl.host === window.location.host) {
                window.location.replace(responseUrl);
                return;
            }
        }
        dispatchUnexpectedErrorOccurred(controller, error);
        return;
    }
    if (response.status == 422 &&
        typeof responseJson === "object" &&
        typeof responseJson.error === "string") {
        dispatchErrorOccurred(controller, new Error(responseJson.error), responseJson.error);
        return;
    }
    return responseJson;
}
class RespuestaErrorInterno extends Error {
}
class RespuestaErrorFormatoIncorrecto extends Error {
    constructor(error) {
        super("Se presentó un problema inesperado.");
        this.error = error;
    }
}
class RespuestaErrorContenidoInvalido extends Error {
    constructor(error) {
        super("Los datos recibidos son inválidos.");
        this.error = error;
    }
}
export function analizadorRespuestaJson(manejadores) {
    const manejadoresResueltos = Object.assign({}, {
        errorInterno() { },
        errorFormatoIncorrecto() { },
        errorContenidoInvalido() { },
        redireccionar(url) { window.location.replace(url); },
    }, manejadores);
    return async (respuesta) => {
        if (respuesta.status >= 500) {
            manejadoresResueltos.errorInterno(new RespuestaErrorInterno(await respuesta.text()));
            return;
        }
        let jsonRespuesta;
        try {
            jsonRespuesta = await respuesta.json();
        }
        catch (error) {
            if (respuesta.redirected) {
                const responseUrl = new URL(respuesta.url);
                if (responseUrl.host === window.location.host) {
                    manejadoresResueltos.redireccionar(responseUrl);
                    return;
                }
            }
            manejadoresResueltos.errorFormatoIncorrecto(new RespuestaErrorFormatoIncorrecto(error));
            return;
        }
        if (respuesta.status == 422) {
            if (jsonRespuesta
                && typeof jsonRespuesta === "object"
                && "error" in jsonRespuesta) {
                manejadoresResueltos.errorContenidoInvalido(new RespuestaErrorContenidoInvalido(jsonRespuesta.error));
            }
            return;
        }
        return jsonRespuesta;
    };
}
//# sourceMappingURL=http_helpers.js.map